import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AQMap = _resolveComponent("AQMap")!
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    widget: _ctx.widget,
    mode: _ctx.widgetMode,
    empty: !_ctx.stations || !_ctx.currentStation,
    padding: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AQMap, {
        ref: "map",
        stations: _ctx.stationList,
        currentStation: _ctx.station
      }, null, 8 /* PROPS */, ["stations", "currentStation"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "mode", "empty"]))
}